import { Suspense, useEffect, useState } from 'react';

import { useRuntimeConfig } from '@xing-com/crate-xinglet/internal';

export type NoSSRLoggedInSuspenseProps = React.PropsWithChildren<{
  fallback?: React.ReactNode;
}>;

export const NoSSRLoggedInSuspense: React.FC<NoSSRLoggedInSuspenseProps> = ({
  children,
  fallback = null,
}) => {
  const [mounted, setMounted] = useState(false);
  const loggedOut = useRuntimeConfig().loginState === 'LOGGED_OUT';

  useEffect(() => {
    setMounted(true);
  }, []);

  const canRender = mounted || loggedOut;

  return (
    <Suspense fallback={fallback}>{canRender ? children : fallback}</Suspense>
  );
};
